import React, { useEffect, useState, useRef } from 'react';
import { withSize } from 'react-sizeme';
import stickybits from 'stickybits';

import useCsvData from '~/kits/general/scripts/hooks/useCsvData';
import d3 from './d3';
import Canvas from './Canvas';
import LineChart from './LineChart';
import EpochBars from './EpochBars';
import epochs from '~/kits/general/config';
import ChartTitle from '~/kits/general/scripts/ChartTitle';
import { is768Query } from '~/core/scripts/mediaquery-helper';
import { clamp } from '~/core/scripts/chart-components/utils';

const isSmallScreen = !is768Query();
const items = epochs.reduce((res, epoch) => res.concat(epoch.items), []);

const margin = {
  top: 20,
  left: 0,
  right: 25,
  bottom: 0
};

const parseRow = r => {
  const splittedDate = r.date.split('-');

  return {
    date: new Date(splittedDate[0], +splittedDate[1] - 1, splittedDate[2]),
    value: +r.value
  };
};

export default withSize()(({ size, activeItemId }) => {
  const data = useCsvData('loess_afd.csv', parseRow);
  const [sticky, setSticky] = useState(false);
  const [width, setWidth] = useState(size.width);
  const chartboxNode = useRef(null);

  useEffect(() => {
    if (!sticky && document.querySelector('.stickycontainer')) {
      const sb = stickybits('.stickycontainer', { useStickyClasses: true });

      sb.update();

      setSticky(sb);
    }
  });

  useEffect(() => {
    if (chartboxNode.current) {
      const padding = Number.parseInt(window.getComputedStyle(chartboxNode.current).paddingLeft);
      setWidth(size.width - (padding * 2));
    }
  }, [chartboxNode.current])

  const height = isSmallScreen ? clamp(window.innerHeight * 0.4, 180, width * 0.9) : width * 0.8;

  if (!data) {
    return false;
  }

  const xScale = d3.scaleLinear()
    .domain([new Date(2013, 0, 1), new Date(2019, 7, 26)])
    .range([margin.left, width - margin.right]);

  const yScale = d3.scaleLinear()
    .domain([0, 20])
    .range([height - margin.bottom, margin.top]);

  const activeItem = items.find(i => i.id === activeItemId);
  const activeEpochId = activeItemId.split('--')[0];

  return (
    <div className="stickycontainer">
      <div className="chartbox__wrapper" ref={chartboxNode}>
        {!isSmallScreen && <ChartTitle />}
        <div style={{ position: 'relative' }}>
          <div className="chart__wrapper">
            <LineChart
              width={width}
              height={height}
              margin={margin}
              xScale={xScale}
              yScale={yScale}
              data={data}
              activeItem={activeItem}
              activeEpochId={activeEpochId}
            />
            <Canvas
              width={width - margin.right}
              height={height - margin.top}
              parseRow={parseRow}
              yScale={yScale}
              xScale={xScale}
              style={{ marginTop: margin.top }}
            />
          </div>
        </div>

        <EpochBars
          activeEpochId={activeEpochId}
          xScale={xScale}
        />
      </div>
    </div>
  );
});
